import { Col, Row } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import settingAPI from '~/api/SettingAPI';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import FormContact from '~/components/FormContact';
import styles from './Contact.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';

const cx = classNames.bind(styles);

const Contact = () => {
    const lat = 106.75874686687453;
    const lng = 21.852455653883165;

    const [listInfo, setListInfo] = useState([]);

    const handleGetListInfo = async () => {
        try {
            const params = {
                fields: '["$all"]',
            };
            let final = [];
            const res = await settingAPI.getListInfo(params);
            if (res.code === 200) {
                const rows = res.results.objects.rows;
                for (let i = 0; i < rows.length; i++) {
                    if (rows[i].type === 'ADDRESS') {
                        final[0] = { ...rows[i], icon: SVGS.IconLocationContact, label: 'Beauty-ms' };
                    }
                    if (rows[i].type === 'HOTLINE') {
                        final[1] = { ...rows[i], icon: SVGS.IconPhoneContact, label: 'Hotline' };
                    }
                    if (rows[i].type === 'EMAIL') {
                        final[2] = { ...rows[i], icon: SVGS.IconEmailContact, label: 'Email' };
                    }
                }
            }
            setListInfo(final);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleGetListInfo();
        document.body.classList.remove('time-picker-booking-custom');
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangLienHe');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('banner')}>
                <img src={IMAGES.ImageBannerServiceProduct} alt="Banner Spa" />
                {/* <span>Contact</span> */}
            </div>
            <div className={cx('google_map')}>
                <iframe
                    title="RIFO"
                    width="100%"
                    height="100%"
                    frameBorder={0}
                    src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDQDOhJAewCe3IhCgSqhYrwwIv4Qqo8CdM&q=${lng},${lat}`}
                />
            </div>
            <div className={cx('contact_info')}>
                <Row justify="center" className={cx('name_section')}>
                    Contact Info
                </Row>
                <Row className={cx('contact_section')}>
                    {listInfo?.length &&
                        listInfo?.map((item, index) => {
                            return (
                                <Col xs={24} md={12} lg={8} key={index}>
                                    <Row className={cx('item')}>
                                        <>
                                            <div>
                                                <Row justify="end">
                                                    <img src={item.icon} className={cx('icon')} alt="" />
                                                </Row>
                                            </div>
                                            <div>
                                                <Row className={cx('label')}>{item.label}</Row>
                                                <Row className={cx('content')}>{index < 3 && item.value}</Row>
                                            </div>

                                            {/* <Col xs={5}>
                                                <Row justify="end">
                                                    <img src={item.icon} className={cx('icon')} alt="" />
                                                </Row>
                                            </Col>
                                            <Col xs={18}>
                                                <Row className={cx('label')}>{item.label}</Row>
                                                <Row className={cx('content')}>{index < 3 && item.value}</Row>
                                            </Col> */}
                                        </>
                                    </Row>
                                </Col>
                            );
                        })}
                </Row>
            </div>
            <div className={cx('form_contact')}>
                <FormContact />
            </div>
        </div>
    );
};

export default Contact;
